export interface EmailRecord {
  id: string;
  recipient: string;
  subject: string;
  template_type: string;
  event_name: string;
  email_type: 'Ticket Email' | 'Email Blast';
  status: 'sent' | 'failed';
  sent_at: string;
  delivered_at?: string;
  opened_at?: string;
  tag: string;
  message_stream: string;
  bounce_details?: {
    ID: number;
    Type: string;
    Email: string;
    MessageID: string;
    Details: string;
    [key: string]: any;
  };
}



export interface EmailTrackerResponse {
  emails: EmailRecord[];
  total: number;
  count: number;
  offset: number;
}

export const emailTrackerService = {
  /**
   * Fetch emails for the organization
   * @param count - Number of emails to fetch (max 100)
   * @param offset - Offset for pagination
   * @returns Promise with email data
   */
  getEmails: async (count: number = 50, offset: number = 0): Promise<EmailTrackerResponse> => {
    const url = `${process.env.REACT_APP_API_URL}/email/tracker/emails?count=${count}&offset=${offset}`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json"
      },
      credentials: 'include'
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Failed to fetch emails: ${response.status} ${errorText}`);
    }

    return response.json();
  },


}; 